const SUBSITE_HIDDEN_BLOCKS = {
  projetgrandplace: ['mapCta', 'urgenceNumbers'],
};

export const isSubsiteBlockHidden = (subSiteSlug, blockName) =>
  Boolean(subSiteSlug && SUBSITE_HIDDEN_BLOCKS[subSiteSlug]?.includes(blockName));
